import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
// import 'amfe-flexible';
import App from './App.vue';
import router from './router';
import store from './store';

import $http from '@/utils/fetch';
import * as $app from '@/utils/app';
import filters from '@/utils/filters';
import CONFIG from '@/config/index';
import { ENV } from '@/config/api';

import '@/assets/scss/index.scss';

import $loading from '@/base/Loading';

import MeishaWatch from 'meisha-fe-watch';

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();
// import '@/utils/ms-jssdk';

MeishaWatch.init({
  isReport: !ENV.DEV,
  reportURL: `//${ENV.TEST ? 'test-' : ''}monitor.meishakeji.com/v1/fex/post_log`, // 向后端提交MeishaWatch收集信息的URL(必填，否则无法提交)
  projectId: 'form_h5' // 日志系统设置的项目英文名（必填，否则无法提交）
});
Vue.use(MeishaWatch.useVue());

Vue.use(filters);
Vue.use($loading);
Vue.use(VueLazyload);

Vue.config.productionTip = false;

window.$http = $http;
window.$app = $app;
window.CONFIG = CONFIG;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
